export default __webpack_public_path__ + "static/media/roundel_dt.cb983fc7.png";